module.exports = __webpack_public_path__ + "ee6fda13a0706cc9ff0f4d7b15ece5d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/HandWhite.jpg
// module id = 1289
// module chunks = 0